import { createBrowserHistory } from 'history';

// this component will be used to redirect user when an error acquired
const history = createBrowserHistory();

export default history;
